<template lang="pug">
  v-dialog(v-model="show"  max-width="1000px"  persistent scrollable )
    v-card
      v-card-title.title {{$t('bankTransactionPage.transaction')}}  {{transactionDetail.transaction.variableSymbol}} / {{transactionDetail.transaction.specificSymbol}}
      v-card-text(style="max-height: 70vh")
      v-tabs
        v-tab {{ $t('bankTransactionPage.propertiesTabLabel') }}
        v-tab {{ $t('bankTransactionPage.amountToWalletTabLabel') }}

        v-tab-item
          BankTransactionPropertiesTab( v-if="transactionDetail" :transactionDetail="transactionDetail" )
        v-tab-item
          BankTransactionAmountToWalletTab( v-if="transactionDetail" :transactionDetail="transactionDetail")
      v-divider
      v-card-actions
        v-row.ma-0
          v-btn(v-if="transactionDetail.transaction.status === 'not_processed'" color="orange" text @click="onResolveTransaction" ) {{ $t('bankTransactionPage.resolveTransaction') }}
          v-spacer
          v-btn(color="primary"  @click="onCloseButtonClick") {{ $t('buttons.closeButtonLabel') }}


</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop,} from 'vue-property-decorator'
import BankTransactionAmountToWalletTab from "@/components/user/BankTransactionAmountToWalletTab.vue";
import BankTransactionPropertiesTab from "@/components/user/BankTransactionPropertiesTab.vue";
import BankTransaction from "@/model/BankTransaction/BankTransaction";

@Component({
  components: {
    BankTransactionPropertiesTab,
    BankTransactionAmountToWalletTab
  },
})
export default class TransactionDetailDialog extends Vue {

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Object, required: false}) readonly transactionDetail!: BankTransaction

  onSubmitButtonClick() {
  }

  onCloseButtonClick(){
    this.$emit('closeDetailDialog')
  }

  onResolveTransaction(){
    this.$emit('resolve')
  }

  mounted() {
  }
}

</script>

<style lang="stylus" scoped>

</style>
